import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import { Box, Button, Grid2, Typography } from '@mui/material'
import CustomDivider from '../../shared/utils/CustomDivider'
import { IdAutoCompleteField } from '../../shared/components/formfields/IdAutoCompleteField'
import { useLmsDropdownOptions } from './option/LsmOption'
import { Field, FieldArray, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { postAddLsm } from '../../assets/nodeApi/postApi/postAdminApi'
import { useMutation } from '@tanstack/react-query'
import { Grid_Gap, Input_Width, Input_Width_LG } from '../../shared/constants'
import { useToaster } from '../../shared/utils/ToasterProvider'
import SprintWrapper from '../../shared/components/admin/SprintWrapper'
import AddIcon from '@mui/icons-material/Add';
import MilestonesWrapper from '../../shared/components/admin/MilestonesWrapper'
import { TextFormField } from '../../shared/components/formfields/TextFormField'
import { useEffect, useRef, useState } from 'react'
import { AutoCompleteField } from '../../shared/components/formfields/AutoCompleteField'
import { FormikQuillField } from '../../shared/components/formfields/FormikQuillField'
import { RadioButtonGroupFormField } from '../../shared/components/formfields/RadioButtonField'
import { DropzoneUploadLargFileField } from '../../shared/components/formfields/DropzoneUploadLargFileField'
import RadioButtonGroup from '../../shared/components/formfields/RadioButtonGroup'
import { useNavigate, useParams} from 'react-router-dom'
import { useGetLmsUpdateContentById } from '../../assets/nodeApi/getApi/getAdminApi'
import { postUpdateLms } from '../../assets/nodeApi/putApi/putAdminApi'
import { FormSkeleton } from '../../shared/utils/SkeletonCom'

const AddLms = () => {
    const navigate = useNavigate();
    const { lmsId } = useParams()
    const { data: lmsFullContent, isLoading } = useGetLmsUpdateContentById(lmsId)
    const [selectedCourseId, setSelectedCourseId] = useState("");
    const [selectedMilestone, setSelectedMilestone] = useState({});
    const [selectedSprint, setSelectedSprint] = useState({});
    const { showToaster } = useToaster();
    const [courseMode, setCourseMode] = useState("");


    // const { lmsGrade, lmsPublication, lmsLangauge, lmsBoard, lmsCourses, lmsCourseType, lmsParagraLanguage, lmsMilestone, lmsSession1, lmsSprint } = useLmsDropdownOptions({
    //     courseId: selectedCourseId,
    //     milestoneFilter: selectedCourseId,
    //     sprintFilter: selectedMilestone?.id,
    //     session1Filter: selectedSprint?.id,
    //     gradeFilter: { status: true },
    //     boardFilter: { status: true },
    //     publicationFilter: { status: true },
    //     languagesFilter: { status: true },
    //      mode: courseMode
    // })



    const {
        lmsGrade,
        lmsPublication,
        lmsLangauge,
        lmsBoard,
        lmsCourses,
        lmsCourseType,
        lmsParagraLanguage,
        lmsMilestone,
        lmsSession1,
        lmsSprint,
        lmsCourseTypeOptions
    } = useLmsDropdownOptions({
        courseId: selectedCourseId,
        milestoneFilter: selectedCourseId,
        sprintFilter: selectedMilestone?.id,
        session1Filter: selectedSprint?.id,
        gradeFilter: { status: true },
        boardFilter: { status: true },
        courseFilter: { mode: courseMode }

    });

    const [uploadMode, setUploadMode] = useState({});

    const CourseLevelOption = [
        { id: 1, label: "Beginner", value: "beginner" },
        { id: 2, label: "Intermediate", value: "intermediate" },
        { id: 3, label: "Expert", value: "expert" },
    ]

    const formikRef = useRef();

    const validationSchema = Yup.object().shape({
        // ---------- TOP LEVEL ----------

        eventId: Yup.number()
            .typeError("Event is required")
            .required("Event is required"),
        type: Yup.string()
            .required("Course Type Filter is required"),


        gradeId: Yup.number()
            .typeError("Grade is required")
            .required("Grade is required"),

        boardId: Yup.number()
            .typeError("Board is required")
            .required("Board is required"),

        publicationId: Yup.number()
            .typeError("Publication is required")
            .required("Publication is required"),

        languageId: Yup.number()
            .typeError("Language is required")
            .required("Language is required"),

        course_type: Yup.string()
            .required("Course type is required"),

        levelId: Yup.string()
            .required("Level is required"),
        sessionId: Yup.number()
            .typeError("Topic (Session) is required")
            .required("Topic (Session) is required"),
        subtopics: Yup.array()
            .of(
                Yup.object().shape({
                    name: Yup.string()
                        .trim()
                        .required("Subtopic name is required"),

                    description: Yup.string()
                        .trim()
                        .required("Subtopic description is required"),

                    paragraphs: Yup.array()
                        .of(
                            Yup.object().shape({
                                description: Yup.string()
                                    .required("Paragraph description is required"),

                                language: Yup.string()
                                    .required("Paragraph language is required"),

                            })
                        )
                        .min(1, "At least one paragraph is required"),
                })
            )
            .min(1, "At least one subtopic is required"),

    });






    const mapTopicsFromApi = (topics = []) => {
        return topics.map((topic) => ({
            sessionId: topic.sessionId,
            subtopics: topic.subtopics.map((sub) => {
                const firstFile = sub.files?.[0] || null;

                return {
                    id: sub.id,
                    name: sub.name || "",
                    description: sub.description || "",

                    // ✅ always arrays, but max 1 item
                    files: firstFile?.file_path ? [firstFile.file_path] : [],
                    file_ids: firstFile?.id ? [firstFile.id] : [],
                    file_descriptions: firstFile?.description
                        ? [firstFile.description]
                        : [],

                    paragraphs: sub.paragraphs.map((p) => ({
                        id: p.id,
                        description: p.description || "",
                        language: p.language,
                    })),
                };
            }),
        }));
    };

    const initialValues = {
        "type": lmsFullContent?.mapping?.type || "",
        "eventId": lmsFullContent?.eventId,
        "gradeId": lmsFullContent?.mapping?.grade?.id,
        "boardId": lmsFullContent?.mapping?.board?.id,
        "publicationId": lmsFullContent?.mapping?.publication?.id,
        "languageId": lmsFullContent?.mapping?.language?.id,


        "course_type": lmsFullContent?.mapping?.course_type,
        "levelId": lmsFullContent?.mapping?.level?.id,
        "sessionId": lmsFullContent?.mapping?.sessionId || lmsFullContent?.mapping?.level?.id,
        "subtopics": [
            {
                "name": "",
                "description": "",
                "files": [],
                "paragraphs": [
                    {
                        "description": "",
                        "language": ""

                    }
                ],
            },

        ]
    };


    const mutationAddLMS = useMutation({
        mutationFn: postAddLsm,
    });

    const mutationUpdateLMS = useMutation({
        mutationFn: ({ formData, id }) => postUpdateLms(formData, id),
    });


    const handleSubmit = (values, { resetForm }) => {
        const formData = new FormData();

        // ---- Top-level fields ----
        formData.append("eventId", String(values.eventId));
        formData.append("type", values.type);
        formData.append("gradeId", String(values.gradeId));
        formData.append("boardId", String(values.boardId));
        formData.append("publicationId", String(values.publicationId));
        formData.append("languageId", String(values.languageId));
        formData.append("course_type", values.course_type);
        formData.append("levelId", String(values.levelId));
        formData.append("sessionId", String(values.sessionId));

        let fileCounter = 1;
        const filesToUpload = [];

        // ---- Build subtopics JSON ----
        const subtopicsWithTempFiles = values.subtopics.map((sub) => {
            const tempFiles = [];
            const fileDescriptions = [];
            const filesArray = Array.isArray(sub.files) ? sub.files : [];

            filesArray.forEach((item) => {
                if (item instanceof File || item?.file instanceof File) {
                    const actualFile = item instanceof File ? item : item.file;
                    const tempRef = `temp://${fileCounter++}`;

                    tempFiles.push(tempRef);
                    fileDescriptions.push(actualFile.name);
                    filesToUpload.push(actualFile);
                } else if (typeof item === "string") {
                    // Existing file URL or path
                    tempFiles.push(item);
                    fileDescriptions.push("URL");
                }
            });

            return {
                ...sub, // preserve id, name, description
                files: tempFiles,
                file_descriptions: fileDescriptions,

                // ...(lmsId ? { file_ids: sub.file_ids || [] } : {}),

                paragraphs: sub.paragraphs.map((p) => ({
                    ...p // preserve paragraph.id and other data
                }))
            };
        });

        // ---- Append subtopics JSON ----
        formData.append("subtopics", JSON.stringify(subtopicsWithTempFiles));

        // ---- Append actual files ----
        filesToUpload.forEach((file) => formData.append("files", file));

        // ---- Mutate ----


        if (lmsId) {
            mutationUpdateLMS.mutate({ formData, id: lmsId }, {
                onSuccess: (res) => {
                    showToaster("LMS Updated successfully!", "", "success");
                    resetForm();
                },
                onError: (err) => {
                    showToaster(
                        err?.response?.data?.message || "Failed to Update LMS",
                        "",
                        "error"
                    );
                },
            });
        } else {
            mutationAddLMS.mutate(formData, {
                onSuccess: (res) => {
                    showToaster("LMS Added successfully!", "", "success");
                    resetForm();
                },
                onError: (err) => {
                    showToaster(
                        err?.response?.data?.message || "Failed to Add LMS",
                        "",
                        "error"
                    );
                },
            });
        }
    };



    const uploadOptions = [
        { label: "Select File", value: "file" },
        { label: "Add Url", value: "url" },
    ]

    useEffect(() => {
        if (lmsFullContent) {
            setSelectedCourseId(lmsFullContent?.eventId);
            setCourseMode(lmsFullContent?.mapping?.type);
        }
    }, [lmsId, isLoading, lmsFullContent])

    return (
        <>
            {
                isLoading && <>
                    <Grid2 container spacing={Grid_Gap}>
                        {
                            [...Array(20)].map((_, index) => (
                                <Grid2 children size={Input_Width_LG} key={index}>
                                    <FormSkeleton height={40} />
                                </Grid2>
                            ))
                        }

                    </Grid2>
                </>
            }

            {
                !isLoading &&
                <NormalContainerWithHeader headerText={lmsId ? "Update LMS" : "Add LMS"}>
                    <Typography>{lmsId ? "Update" : "Fill"} in the details to launch a LMS</Typography>
                    <CustomDivider />
                    <Typography>Choose the course name from drop down</Typography>
                    <CustomDivider />
                    <Formik
                        innerRef={formikRef}
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmit}
                        enableReinitialize>
                        {({ values, resetForm, setFieldValue }) => (
                            <Form>
                                <Grid2 container spacing={Grid_Gap}>
                                    <Grid2 children size={Input_Width_LG}>
                                        <Field
                                            name="type"
                                            component={AutoCompleteField}
                                            label="Course Type Filter"
                                             isRequired={true}
                                            options={lmsCourseTypeOptions.options}
                                            onValueChange={(value) => {
                                                setCourseMode(value?.value);
                                                setFieldValue("eventId", "");
                                                setSelectedCourseId(null);
                                            }}
                                            disabled={lmsId}
                                        />
                                    </Grid2>
                                    <Grid2 children size={Input_Width_LG}>
                                        <Field
                                            name="eventId"
                                            component={IdAutoCompleteField}
                                            options={lmsCourses.options}
                                            label="Course Name"
                                            isRequired={true}
                                            isLoading={lmsCourses.isLoading}
                                            onValueChange={(newValue) => {
                                                if (newValue) {
                                                    setSelectedCourseId(newValue.id);
                                                    setSelectedMilestone({})
                                                    setSelectedSprint({})
                                                    setFieldValue("milestoneId", "")
                                                    setFieldValue("sprintId", "")
                                                    setFieldValue("sessionId", "")
                                                } else {
                                                    setSelectedCourseId(null);
                                                }
                                            }}
                                            disabled={!courseMode}
                                        />


                                    </Grid2>
                                    <Grid2 children size={Input_Width_LG}>
                                        <Field
                                            name="course_type"
                                            component={AutoCompleteField}
                                            options={lmsCourseType.options}
                                            label="Course Type"
                                            isRequired={true}
                                            disabled={lmsId}

                                        />
                                    </Grid2>
                                    <Grid2 children size={Input_Width_LG}>
                                        <Field
                                            name="boardId"
                                            component={IdAutoCompleteField}
                                            options={lmsBoard.options}
                                            label="Board"
                                            isRequired={true}
                                            isLoading={lmsBoard.isLoading}
                                            disabled={lmsId}
                                        />
                                    </Grid2>
                                    <Grid2 children size={Input_Width_LG}>
                                        <Field
                                            name="languageId"
                                            component={IdAutoCompleteField}
                                            options={lmsLangauge.options?.filter((item) => String(item.status) === "1")}
                                            label="Language"
                                            isRequired={true}
                                            isLoading={lmsLangauge.isLoading}
                                            disabled={lmsId}
                                        />
                                    </Grid2>
                                    <Grid2 children size={Input_Width_LG}>
                                        <Field
                                            name="gradeId"
                                            component={IdAutoCompleteField}
                                            options={lmsGrade.options}
                                            label="Grade"
                                            isRequired={true}
                                            isLoading={lmsGrade.isLoading}
                                            disabled={lmsId}

                                        />
                                    </Grid2>

                                    <Grid2 children size={Input_Width_LG}>
                                        <Field
                                            name="publicationId"
                                            component={IdAutoCompleteField}
                                            options={lmsPublication.options?.filter((item) => String(item.status) === "1")}
                                            label="Publications"
                                            isRequired={true}
                                            isLoading={lmsPublication.isLoading}
                                            disabled={lmsId}

                                        />
                                    </Grid2>




                                    <Grid2 children size={12}>
                                        <Field
                                            name="levelId"
                                            component={RadioButtonGroupFormField}
                                            label="Course Level"
                                            isRequired
                                            options={CourseLevelOption}
                                            row
                                            isId={true}
                                            disabled={lmsId}
                                        />
                                    </Grid2>

                                    <Grid2 children size={Input_Width_LG}>
                                        <Field
                                            name="milestoneId"
                                            component={IdAutoCompleteField}
                                            options={lmsMilestone.options}
                                            label="Milestone"
                                            isRequired={true}
                                            isLoading={lmsMilestone.isLoading}
                                            onValueChange={(newValue) => {
                                                if (newValue) {
                                                    setSelectedMilestone(newValue);
                                                    setSelectedSprint({})
                                                    setFieldValue("sprintId", "")
                                                    setFieldValue("sessionId", "")

                                                } else {
                                                    setSelectedCourseId(null);
                                                }
                                            }}

                                        />
                                    </Grid2>
                                    <Grid2 children size={Input_Width_LG}>
                                        <Field
                                            name="sprintId"
                                            component={IdAutoCompleteField}
                                            options={lmsSprint.options}
                                            label="Sprint"
                                            isRequired={true}
                                            isLoading={lmsSprint.isLoading}
                                            onValueChange={(newValue) => {
                                                if (newValue) {
                                                    setSelectedSprint(newValue);
                                                    setFieldValue("sessionId", "")
                                                } else {
                                                    setSelectedSprint(null);
                                                }
                                            }}

                                        />
                                    </Grid2>
                                    <Grid2 children size={12}>
                                        <Field
                                            name={`sessionId`}
                                            component={IdAutoCompleteField}
                                            options={lmsSession1.options}
                                            label="Topic"
                                            isRequired={true}
                                            isLoading={lmsSession1.isLoading}

                                        />
                                    </Grid2>
                                </Grid2>
                                <CustomDivider />
                                <FieldArray name={`subtopics`}>
                                    {({ push: pushSubtopic, remove: removeSubtopic }) => (
                                        <>
                                            {values.subtopics?.map((subTopic, sIndex) => {
                                                const key = `${sIndex}`;
                                                const apiSubFiles = lmsFullContent?.subtopics?.[sIndex]?.files || [];

                                                const hasVideo =
                                                    apiSubFiles.some(f => f.file_type === "video");

                                                const mode = uploadMode[key]
                                                // || (lmsId && hasVideo ? "url" : "file");



                                                return (
                                                    <MilestonesWrapper
                                                        key={sIndex}
                                                        headerText={`SubTopic ${sIndex + 1}`}
                                                        onDelete={() => removeSubtopic(sIndex)}
                                                        sx={{ border: "1px solid #4169E1" }}
                                                    >
                                                        <Grid2 container spacing={Grid_Gap}>
                                                            <Grid2 children size={12}>
                                                                <Field
                                                                    name={`subtopics[${sIndex}].name`}
                                                                    component={TextFormField}
                                                                    label="Subtopic Name"
                                                                    isRequired={true}
                                                                />
                                                            </Grid2>
                                                            <Grid2 children size={12}>
                                                                <Field
                                                                    name={`subtopics[${sIndex}].description`}
                                                                    component={TextFormField}
                                                                    label="Description"
                                                                    isRequired={true}
                                                                    multiline
                                                                    row={3}
                                                                />
                                                            </Grid2>
                                                            <Box sx={{ display: "flex", flexDirection: "column" }}>
                                                                <Typography variant="subtitle1" mb={1}>
                                                                    Choose file type
                                                                </Typography>
                                                                <RadioButtonGroup
                                                                    options={uploadOptions}
                                                                    value={mode}
                                                                    onChange={(val) => {
                                                                        setUploadMode(prev => ({
                                                                            ...prev,
                                                                            [key]: val,
                                                                        }));
                                                                        formikRef.current.setFieldValue(
                                                                            `subtopics[${sIndex}].files`,
                                                                            []
                                                                        );
                                                                    }}

                                                                    row
                                                                />

                                                            </Box>

                                                            {mode === "file" && (
                                                                <Field
                                                                    name={`subtopics[${sIndex}].files[0]`}
                                                                    component={DropzoneUploadLargFileField}
                                                                    multiple
                                                                    label="Upload File(s)"
                                                                    fileDetail={apiSubFiles[0]}
                                                                />
                                                            )}


                                                            {mode === "url" && (
                                                                <Field
                                                                    name={`subtopics[${sIndex}].files[0]`}
                                                                    component={TextFormField}
                                                                    label="Enter URL"
                                                                    placeholder="https://..."

                                                                />
                                                            )}
                                                        </Grid2>
                                                        <CustomDivider />
                                                        <FieldArray name={`subtopics[${sIndex}].paragraphs`}>
                                                            {({ push: pushParagraph, remove: removeParagraph }) => (
                                                                <>

                                                                    {subTopic?.paragraphs?.map((paragraph, pIndex) => (
                                                                        <SprintWrapper
                                                                            key={pIndex}
                                                                            headerText={`Paragraph ${pIndex + 1}`}
                                                                            onDelete={() => removeParagraph(pIndex)}
                                                                        >
                                                                            <Grid2 container spacing={Grid_Gap}>
                                                                                <Grid2 children size={12}>
                                                                                    <Field
                                                                                        name={`subtopics[${sIndex}].paragraphs[${pIndex}].description`}
                                                                                        component={FormikQuillField}
                                                                                        label="Paragraph"
                                                                                        isRequired={true}
                                                                                    />
                                                                                </Grid2>
                                                                                <Grid2 children size={12}>
                                                                                    <Field
                                                                                        name={`subtopics[${sIndex}].paragraphs[${pIndex}].language`}
                                                                                        component={AutoCompleteField}
                                                                                        options={lmsParagraLanguage.options}
                                                                                        label="Language"
                                                                                        isRequired={true}

                                                                                    />
                                                                                </Grid2>



                                                                            </Grid2>
                                                                            <CustomDivider />




                                                                        </SprintWrapper>
                                                                    ))}
                                                                    <CustomDivider />
                                                                    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                                                                        <Button
                                                                            startIcon={<AddIcon />}
                                                                            onClick={() =>
                                                                                pushParagraph({
                                                                                    description: '',

                                                                                })
                                                                            }
                                                                            variant="contained"

                                                                        >
                                                                            Add Paragraph
                                                                        </Button>
                                                                    </Box>
                                                                </>
                                                            )}
                                                        </FieldArray>


                                                    </MilestonesWrapper>
                                                )
                                            }

                                            )}

                                            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                                                <Button
                                                    startIcon={<AddIcon />}
                                                    onClick={() =>
                                                        pushSubtopic({
                                                            name: '',
                                                            description: '',
                                                            files: null,
                                                            paragraphs: [
                                                                {
                                                                    description: "",
                                                                    language: ""
                                                                }
                                                            ],

                                                        })
                                                    }
                                                    variant="outlined"

                                                >
                                                    Add SubTopic
                                                </Button>
                                            </Box>
                                        </>
                                    )}
                                </FieldArray>




                                <CustomDivider />

                                <Grid2 container spacing={Grid_Gap} mt={2}>
                                    <Grid2 children size={Input_Width}>
                                        <Button
                                            variant="outlined"
                                            type="button"
                                            onClick={() => {
                                                resetForm();
                                            }}
                                            fullWidth
                                        >
                                            Reset
                                        </Button>
                                    </Grid2>
                                    <Grid2 children size={Input_Width}>
                                        <Button
                                            variant="contained"
                                            type="submit"
                                            fullWidth
                                            disabled={mutationAddLMS.isPending || mutationUpdateLMS.isPending}
                                        >

                                            {
                                                (mutationAddLMS.isPending || mutationUpdateLMS.isPending)
                                                    ? (lmsId ? "Updating..." : "Submitting...")
                                                    : (lmsId ? "Update" : "Submit")
                                            }


                                        </Button>
                                    </Grid2>

                                </Grid2>

                            </Form>
                        )}
                    </Formik>
                </NormalContainerWithHeader>
            }

        </>
    )
}

export default AddLms






